import type { SVGComponentProps } from 'BreetHelpers';

export const ScannerSavedAddressIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		{...rest}
		width='30'
		height='30'
		viewBox='0 0 30 30'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<rect
			width='30'
			height='30'
			rx='15'
			fill='#F7F8F8'
		/>
		<path
			opacity='0.4'
			d='M14.9999 20.8337C17.7931 20.8337 20.0574 18.5694 20.0574 15.7762C20.0574 12.9831 17.7931 10.7188 14.9999 10.7188C12.2067 10.7188 9.94238 12.9831 9.94238 15.7762C9.94238 18.5694 12.2067 20.8337 14.9999 20.8337Z'
			fill='#022745'
		/>
		<path
			d='M15 16.0221C14.7608 16.0221 14.5625 15.8238 14.5625 15.5846V12.668C14.5625 12.4288 14.7608 12.2305 15 12.2305C15.2392 12.2305 15.4375 12.4288 15.4375 12.668V15.5846C15.4375 15.8238 15.2392 16.0221 15 16.0221Z'
			fill='#022745'
		/>
		<path
			d='M16.6857 10.0138H13.314C13.0807 10.0138 12.894 9.82714 12.894 9.5938C12.894 9.36047 13.0807 9.16797 13.314 9.16797H16.6857C16.919 9.16797 17.1057 9.35464 17.1057 9.58797C17.1057 9.8213 16.919 10.0138 16.6857 10.0138Z'
			fill='#022745'
		/>
	</svg>
);
